import { useQuery } from 'react-query'
import axios from 'lib/axiosConfig'
import { selectLanguageInCodeList } from 'lib/utils'

export const useCodeList = (codeListName: string, getTranslated?: boolean) => {
  const {
    isLoading,
    isFetching,
    error,
    data: response,
  } = useQuery(
    [`getCodeList-${codeListName}`],
    async () => axios.get(`/v1/code-lists/${codeListName}`),
    {
      keepPreviousData: true,
    }
  )

  if (!getTranslated) {
    const codeListTypes = response?.data.data.codeListRecord || []
    return { codeListTypes, isLoading, error, isFetching }
  }
  const codeListTypes = response
    ? response.data.data.codeListRecord.map(
        (code: {
          code: string
          name: { $: string; '@languageCode': string }[]
        }) => {
          const labelInLang = selectLanguageInCodeList(code.name)
          return {
            value: code.code,
            label: labelInLang?.$ ?? code.code,
          }
        }
      )
    : []
  return { codeListTypes, isLoading, error, isFetching }
}
